// extracted by mini-css-extract-plugin
export default {"agreement":"YandexPay-module__agreement__Q4XGm","yandexPayContainer":"YandexPay-module__yandexPayContainer__Qaq1C"};